export enum SuperTableColumnWidth {
    DYNAMIC = 'dynamic',
    SMALL = 'small',
    STANDARD = 'standard',
    LARGE = 'large',
}
